// Note: \u00A0 is a non-breaking space to ensure the phone number does
// not get split across multiple lines.
const phoneNumberFormatter = (phoneNumber) => {
	if (!phoneNumber?.length) return "";
	return phoneNumber.replace(
		/(\d{4})\D?(\d{3})\D?(\d{3})/,
		"$1\u00A0$2\u00A0$3",
	);
};

export default phoneNumberFormatter;
